import React from '../helpers/react'
import {connect} from '../helpers/composeReducer.js';
import {toggleFullscreen} from '../actions/ui.action.js';
import {tocToggleChapter, toggleTOC} from '../actions/toc.action';
import {closeAllSolutions, openAllSolutions} from '../actions/problem.action';
import classList from 'ereader-core/dist/classList';
import {getHookClass} from '../helpers/cssHooks.js';
import {ViewTypes} from '../reducers/index.js';
import {OPEN_STATUS_OPEN} from '../reducers/ui.reducer.js';
import ToolbarNavigation from './ToolbarNavigation.js';
import BookmarkTab from '../components/BookmarkTab.js';
import MobileTab from '../components/MobileTab.js';

export const Toolbar = React.createClass({
	areAllShown: function() {
        return this.props.all_steps_open_status == OPEN_STATUS_OPEN;
	},
    toggle : function(){
        this.props.toggleTOC();
        if(!this.props.toc_visible) {
            document.getElementsByClassName('chapter-current')[0].focus();
        }
    },
    toggleShowAll : function(){
        if (this.areAllShown()) {
            this.props.closeAllSolutions();
        } else {
            this.props.openAllSolutions();
        }
    },
    toggleFullscreeen: function(){
        this.props.toggleFullscreen();
    },
    keyDownTOC: function(e){
        e.preventDefault();
        if (e.keyCode === 9 && !e.shiftKey) {
            if (this.props.toc_visible) {
                document.getElementsByClassName('chapter-current')[0].focus();
            }
            else if (!this.props.show_mobile && !this.props.show_bookmark) {
                document.getElementById('show-all-steps').focus();
            }
            else if (!this.props.show_mobile) {
                document.getElementById('bookmark-tab').focus();
            }
            else {
                document.getElementById('mobile-tab').focus();
            }
          return false;
        }
        // # Accessibility -- let element respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let element respond to Shift + Tab
        if(e.shiftKey && e.keyCode === 9) {
            const breadcrumbLink = document.getElementById('chapter-link-id');
            const thumbDown = document.getElementsByClassName('thumb thumb-down');
            if(breadcrumbLink && !this.props.is_fullscreen) {
                breadcrumbLink.focus();
            }
            else if(thumbDown.length > 0 && this.props.is_fullscreen) {
              thumbDown[0].focus();
            }
        }
    },
    keyDownShowAllSteps: function(e){
        e.preventDefault();
        // # Accessibility -- let element respond to Tab
        if (e.keyCode === 9) {
            if(!this.props.show_fullscreen) {
                document.getElementById('problem-previous').focus();
            }
            else {
                document.getElementById('fullscreen').focus();
            }
        }
        // # Accessibility -- let element respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let element respond to Shift + Tab
        if(e.shiftKey && e.keyCode === 9) {
            if(this.props.show_bookmark) {
                document.getElementById('bookmark-tab').focus();
            }
            else if(this.props.show_mobile) {
                document.getElementById('mobile-tab').focus();
            }
            else {
                document.getElementById('toc-button').focus();
            }
        }
    },
    keyDownFullScreen: function(e){
        e.preventDefault();
        if (e.keyCode === 9 && !e.shiftKey) {
            if(document.getElementById('problem-previous').getAttribute('aria-label') != "") {
                document.getElementById('problem-previous').focus();
            }
            else if(document.getElementsByClassName('step-header').length > 0) {
              document.getElementsByClassName('step-header')[0].focus();
            }
        }
        // # Accessibility -- let element respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let element respond to Shift + Tab
        if(e.shiftKey && e.keyCode === 9) {
            document.getElementById('show-all-steps').focus();
        }
    },

	render : function(){
        let chapter_name = this.props.current_chapter.chapterName;
        let problem_name = this.props.problem.problemName;
        let titleText = '';

        if (chapter_name || problem_name) {
            titleText = this.props.getDef('toolbar.name', {
                chapter_name: this.props.current_chapter.chapterName,
                problem_name: this.props.problem.problemName
            }, {
                problem_exists: this.props.problem.problem_exists
            });
        } else {
            titleText = this.props.getDef('toolbar.name.empty');
        }

        let toggleButtonLabel = "Table of Contents";
        let showHideButtonLabel = "Show All Steps";
        let fullScreenButtonLabel = "Toggle Full Screen";

		let toggleButtonClassNames = classList('button','button-icon','toggle-button-toolbar');
        let fullscreenButtonClassNames = classList('button','button-icon', 'fullscreen');

        if (this.props.toc_visible) toggleButtonClassNames.push('selected');
        fullscreenButtonClassNames.push(this.props.is_fullscreen ? 'contract' : 'expand');

		let showHideText = this.areAllShown()
			? this.props.getDef('toolbar.toggle-on')
			: this.props.getDef('toolbar.toggle-off');

        let showHideAllClass = classList(this.areAllShown() ? '' : 'on', 'toggle-button');
        let showHideButton = this.props.problem.has_access
            ? <div className="show-hide-all" onClick={this.toggleShowAll}>
                <label>{this.props.getDef('toolbar.show-all-steps')}:</label>
                <button tabIndex="0" id="show-all-steps" onKeyDown={(e)=>this.keyDownShowAllSteps(e)} className={showHideAllClass} role="switch"
                        aria-checked={this.props.all_steps_open_status === 'open' ? true: false}
                        aria-label={this.props.all_steps_open_status === "open" ? "Hide All Steps":"Show All Steps"}
                >
                    <span>{showHideText}</span>
                </button>
            </div>
            : '';

        let mainClass = classList('toolbar', getHookClass('Toolbar'));

        if (!this.props.show_fullscreen) {
            mainClass.push('no-fullscreen');
        }

        let bookmarkTab = [];
        if (this.props.show_bookmark && this.props.problem.has_access) {
            bookmarkTab.push(<BookmarkTab key='bookmark-tab' />);
        }

        let mobileTab = [];
        let divClassName = classList('divClass');
        if(this.props.show_mobile && this.props.problem.has_access){
            mobileTab.push(<MobileTab key='mobile-tab' />);
        }

        let title_navigation = [];

        if (this.props.view == ViewTypes.TOP_TOOLBAR) {
            title_navigation.push(<ToolbarNavigation key='toolbar-navigation' params={this.props.params} />);
        } else {
            title_navigation.push(<button tabIndex="0" id='toc-button' onKeyDown={(e)=>this.keyDownTOC(e)} key='toc-toggle-button' className={toggleButtonClassNames} onClick={this.toggle} role="switch" aria-checked={this.props.toc_visible} aria-label={this.props.toc_visible ? "Close Table of Contents":"Open Table of Contents"}></button>);
            title_navigation.push(<h2 key='toolbar-title' className='title'>{titleText}</h2>);
        }


        return (
			<header className={mainClass} tabIndex="-1">
                <div className="visually-hidden" id="notification" aria-live="polite" aria-hidden={true}></div>
                {title_navigation}
                <div id="float-right-container">
                    {mobileTab}
                    {bookmarkTab}
                    {showHideButton}
                    {this.props.show_fullscreen ? (<button id='fullscreen' tabIndex="0" onKeyDown={(e)=>this.keyDownFullScreen(e)} className={fullscreenButtonClassNames} onClick={this.toggleFullscreeen} role="switch" aria-checked={this.props.is_fullscreen} aria-label={this.props.is_fullscreen ? "Normal Display":"Full Screen"}></button>) : ''}
                </div>
            </header>
		);
	}
});

export function populateProps(state){
	return {
		toc : state.toc.toc,
		current_chapter : state.problem.chapter,
		problem : state.problem,
		toc_visible : state.toc.visible,
        is_fullscreen: state.ui.is_fullscreen,
        all_steps_open_status : state.ui.all_steps_open_status,
        show_fullscreen : state.options.show_fullscreen,
        show_bookmark : state.options.show_bookmark,
        show_mobile : state.options.show_mobile,
        view : state.options.view,
        getDef : state.helpers.getDef
	};
}

export default connect(populateProps, {
	tocToggleChapter,
	toggleTOC,
	openAllSolutions,
	closeAllSolutions,
    toggleFullscreen
})(Toolbar);



// WEBPACK FOOTER //
// ./src/components/Toolbar.js